import React, { useMemo, useState, useCallback, useEffect } from "react";
import { Offcanvas } from "react-bootstrap";
import { fetchLocation } from "../../../../../Request/LoginRequests";
import { useDispatch } from "react-redux";
import { setCurrentLocation } from "../../../../../Redux/Actions/userActions";
import { useSelector } from "react-redux";
const PIN = 124507;
const SelectArea = ({ show, setShowbtmSheet }) => {
  const [areas, setAreas] = useState([]);
  const [areaSelected, setAreaSelected] = useState(null);
  const dispatch = useDispatch();
  const userCurrentLocation = useSelector(
    (state) => state.user.currentLocation
  );
  //GETTING ALL AVIALABLE AREAS

  const getAreas = useCallback(() => {
    fetchLocation(PIN).then((data) => setAreas(data));
  }, [fetchLocation, PIN]);

  useEffect(() => {
    getAreas();
  }, [getAreas]);

  //BOOTSTRAP OFFCANVAS
  const handleClose = () => {
    setShowbtmSheet(false);
  };

  const backdrop = useMemo(
    () => ({
      name: "Eable backdrop",
      scroll: false,
      backdrop: true,
    }),
    []
  );

  //AREA SELECTED
  const areaSelectedHandler = useCallback(
    (index, area) => {
      //mark the selected checkbox
      setAreaSelected(index);

      //close the bottomsheet after a 300ms delay
      setTimeout(() => {
        handleClose();
      }, 300);

      //dispatch the new seleted area
      const areaUpdated = {
        ...userCurrentLocation,
        area: area.placeName,
        city: area.adminName3,
        lat: area.latitude,
        long: area.longitude,
        pincode: area.postalCode,
        state: area.adminName1,
      };
      dispatch(setCurrentLocation(areaUpdated));
    },
    [areaSelected]
  );

  //MAIN JSX CODE
  return (
    <Offcanvas
      className="bg-transparent h-auto"
      show={show}
      placement="bottom"
      onHide={handleClose}
      {...backdrop}
    >
      <Offcanvas.Body>
      <div
          className="bi bi-x-circle fs-lg mx-auto text-white"
          onClick={() => setShowbtmSheet(false)}
        ></div>
        <div className="offcanvas-header">
          <h3 className="offset-title">Change Language</h3>
        </div>
        <div className="offcanvas-body bg-white p-16">
        {areas.map((area, index) => (
          <div
            key={area?.latitude}
            className={
              "selectArea" + (index === areaSelected ? " checked" : "")
            }
            onClick={() => {
              areaSelectedHandler(index, area);
            }}
          >
            {area?.placeName} &nbsp;
            {area?.postalCode}
          </div>
        ))}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default SelectArea;
